import jodit from './jodit'
import phone from './phone'

const validates = {
  jodit,
  phone,
}

export default validates
